import { Box, Checkbox, Flex, ScrollArea, Spinner, Table } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useJobApplicants } from '../job-applicants-provider';
import { JobApplcantRow } from './job-applicant-row';

import './job-applicants-table.scss';

function JobApplicantsTableView() {
   const jobApplicants = useJobApplicants();

   return (
      <Box p="0" minHeight="200px" className="job-applicants-table">
         <ScrollArea scrollbars="both" type="auto" style={{ height: 'fit-content', minHeight: 200 }}>
            <Table.Root size="3" layout="auto" variant="surface">
               <Table.Header>
                  <Table.Row>
                     <Table.ColumnHeaderCell width="80px" maxWidth="80px" align="center">
                        <Flex gap="1" justify="center">
                           <Checkbox
                              size="3"
                              color="blue"
                              checked={jobApplicants.selectedAll}
                              onCheckedChange={(cheked) => {
                                 if (cheked) {
                                    jobApplicants.onSelectAll();
                                 } else {
                                    jobApplicants.onDeselectAll();
                                 }
                              }}
                              highContrast
                           ></Checkbox>
                        </Flex>
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell>
                        <Flex gap="1" align="center">
                           <span className="header-label">Title</span>
                        </Flex>
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell>
                        <Flex gap="1" align="center">
                           <span className="header-label">Дата відгуку</span>
                        </Flex>
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell>
                        <Flex gap="1" justify="center">
                           <span className="header-label">Рейтинг</span>
                        </Flex>
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell justify="center">
                        <Flex gap="1" align="center">
                           <span className="header-label"> Статус</span>
                           {jobApplicants.statusChangeState.status === 'pending' && <Spinner />}
                        </Flex>
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell justify="center">Тип резюме</Table.ColumnHeaderCell>
                  </Table.Row>
               </Table.Header>

               <Table.Body>
                  {jobApplicants.rawApplicants.map((candidate) => {
                     return <JobApplcantRow key={candidate.user_id} candidate={candidate} />;
                  })}
               </Table.Body>
            </Table.Root>
         </ScrollArea>
      </Box>
   );
}

export const JobApplicantsTable = observer(JobApplicantsTableView);
